module.exports = __webpack_public_path__ + "static/media/polden_logo.3981e2fb.png";


//////////////////
// WEBPACK FOOTER
// ./src/img/polden_logo.png
// module id = 171
// module chunks = 1